import { Component, OnDestroy, OnInit } from '@angular/core';
import { PatientsApplicationsService } from '../../../../shared/services/patients-applications.service';
import { Subject, takeUntil } from "rxjs";
import { APP_CONFIG } from "../../../../../environments/configurations/configurations";
import { TableColumn } from '../../../../shared/models/table-column';
import { PatientDTO } from '../../../../shared/models/patientDTO';
import { LazyLoadEvent } from 'primeng/api';

@Component({
  selector: 'app-applications-patients-list',
  templateUrl: './applications-patients-list.component.html',
  styleUrls: ['./applications-patients-list.component.css'],
})

export class ApplicationsPatientListComponent implements OnInit, OnDestroy {
  patientData: PatientDTO[] = [];
  sourceDate!: PatientDTO[];
  APP_CONFIG = APP_CONFIG;
  totalRecords = 2;
  destroy$: Subject<any> = new Subject<any>();
  loading: boolean = false;
  columns: TableColumn[] = [
    { field: 'id', title: 'No.', style: 'width:5rem' },
    { field: 'mrn', title: 'MRN', filter: { type: 'numeric' } },
    { field: 'name', title: 'Patient Name', filter: { type: 'text' }, style: 'white-space: break-spaces;' },
    { field: 'idNumber', title: 'National ID', filter: { type: 'numeric' } },
    { field: 'birthDate', title: 'Date Of Birth', style: 'width:5rem' },
    { field: 'applicationDate', title: 'Request Date', style: 'width:5rem'},
    {
      field: 'applicationStatus',
      title: 'Status',
      //filter: {
      //  type: 'dropdown', options: [
      //    { label: 'Pending', value: 'PENDING' },
      //    { label: 'Incomplete', value: 'INCOMPLETE' },
      //    { label: 'Invalid', value: 'INVALID' },
      //    { label: 'Accepted', value: 'ACCEPTED' },
      //    { label: 'Rejected', value: 'REJECTED' },
      //    { label: 'Rescheduled', value: 'RESCHEDULED' },
      //    { label: 'Confirmed', value: 'CONFIRMED' },
      //  ]
      //}
    }
  ];

  constructor (
    private PatientsApplicationsService: PatientsApplicationsService,
  ) {}

  ngOnInit(): void {
    this.loading = true;
    var event = { first: 0, rows: 10};
    this.getPatients(event);
  }

  ngOnDestroy(): void {
    this.destroy$.next('');
    this.destroy$.complete();
  }

  validateNumber(event: any) {
    const keyCode = event.keyCode;
    const excludedKeys = [8, 37, 39, 46];

    // Allow copy and paste
    if (event.ctrlKey && (keyCode === 86 || keyCode === 67)) {
      return;
    }

    if (!((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105) || excludedKeys.includes(keyCode))) {
      event.preventDefault();
    }
  }

  onFilter(even: any) {
    if (even) {
      this.patientData = this.sourceDate.filter((res) => (res?.patientApplicationSet[0]?.applicationStatus == even));
    } else {
      this.patientData = this.sourceDate;
    }
  }

  getPatients(event: LazyLoadEvent) {
     console.log(event)
    if (event.sortField == "applicationDate" || event.sortField == "applicationStatus") {
     return
    }
    this.loading = true;
    this.PatientsApplicationsService.getData(event).pipe(takeUntil(this.destroy$)).subscribe(
      (data: any) => {
        data.content.map((item: any) => {
          if (item['applicationStatus'])
            item['applicationStatus'] = item.patientApplicationSet[0].applicationStatus;
          if (item['mrn'])
            item['mrn'] = item['mrn'] ? item['mrn'].toString().replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') : item['mrn'];
          if (item['patientApplicationSet']) {
            item.applicationDate = item.patientApplicationSet[0]?.applicationDate;
            item.applicationStatus = item.patientApplicationSet[0]?.applicationStatus;
          }
          return item;
        });
        this.loading = false;
        this.patientData = data.content;       //.sort((a: any, b: any) => a.id - b.id)
        this.sourceDate = data.content;//.sort((a: any, b: any) => a.id - b.id);
        this.totalRecords = data.totalElements;
      },
      () => {
        this.loading = false;
      });
  }
}
